import {useUserContext} from "../../../../contexts";
import {newItemAnimation, staticFrame} from "../../../../assets";
import {useState, useEffect, useRef} from "preact/compat";

const buttonIconHelper = (stage = "default") => {
    const ICONS_ENUM = {
        default:      staticFrame,
        hasItems:     staticFrame,
        isAddingItem: newItemAnimation
    }

    return ICONS_ENUM[stage];
}

export const useMinicartButton = () => {
    const [currentIconState, setCurrentIconState] = useState({
        icon:          "default",
        displayAmount: false,
        amount:        0
    });

    const standardImageRef = useRef(null);

    // Destructured the needed cart data from the user context
    const [{}, {}, {cartData}] = useUserContext();

    // Destructured the cart data
    // eslint-disable-next-line no-unused-vars
    const {cartId, qtyItems} = cartData;

    useEffect(() => {
        if (qtyItems === 0) {
            setCurrentIconState({
                displayAmount: false,
                icon: "default",
                amount: qtyItems
            });
        } else {
            standardImageRef.current.src = newItemAnimation;

            setCurrentIconState(prevState => {
                return {
                    ...prevState,
                    icon: "isAddingItem",
                    amount: qtyItems
                }
            });

            const timer = setTimeout(() => {
                setCurrentIconState(prevState => {
                    return {
                        ...prevState,
                        displayAmount: true
                    }
                })

                clearTimeout(timer);
            }, 1700);
        }
    }, [qtyItems]);

    return {
        currentIconState,
        qtyItems,
        standardImageRef,
        buttonIconHelper
    }
}
